import { Alert } from 'antd';
import styled from 'styled-components';

export default styled(Alert)`
	// Add your styles here
`;
